import { useEffect, useRef } from 'react';

const partners = [
  'Crown Castle', 'Smartlink', 'Verta Wireless', 'Sonic', 'Black & Veatch',
  'Network Connex', 'MasTec', 'NextGen', 'GTA',
  'Pyramid Network Services', 'ANSCO', 'Mountain Ltd',
  'SME Group', 'Bluepeak', 'Illuminating Concepts',
];

export default function PartnersSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = sectionRef.current?.querySelectorAll('.fade-in-child');
            children?.forEach((child, i) => {
              const el = child as HTMLElement;
              setTimeout(() => {
                el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
                el.style.opacity = '1';
                el.style.transform = 'translateY(0)';
              }, i * 50);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 lg:py-28 bg-[#E8EFF6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p
            className="fade-in-child text-[#0050B2] text-sm font-semibold uppercase tracking-widest mb-3"
            style={{ opacity: 0, transform: 'translateY(20px)' }}
          >
            Industry Partners
          </p>
          <h2
            className="fade-in-child text-3xl lg:text-4xl font-bold text-[#001F4E]"
            style={{ opacity: 0, transform: 'translateY(20px)' }}
          >
            Trusted by Industry Leaders
          </h2>
          <p
            className="fade-in-child text-gray-500 mt-4 text-base"
            style={{ opacity: 0, transform: 'translateY(20px)' }}
          >
            We work alongside some of the most respected names in the telecommunications industry.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {partners.map((partner, i) => (
            <div
              key={i}
              className="fade-in-child bg-white rounded-lg px-5 py-3 text-sm font-semibold text-[#001F4E] hover:bg-[#0050B2] hover:text-white transition-colors duration-200 cursor-default whitespace-nowrap"
              style={{ opacity: 0, transform: 'translateY(20px)' }}
            >
              {partner}
            </div>
          ))}
        </div>

        <div
          className="fade-in-child mt-10 text-center"
          style={{ opacity: 0, transform: 'translateY(20px)' }}
        >
          <div className="inline-flex items-center gap-3 bg-white rounded-lg px-6 py-3 border border-[#0050B2]/20">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-verified-badge-line text-[#0050B2] text-lg" />
            </div>
            <span className="text-[#001F4E] text-sm font-semibold">Avetta Member</span>
          </div>
        </div>
      </div>
    </section>
  );
}
